import React from 'react';
import { assessmentKey, packLevelItems } from '../../data/demo';
interface Props {
  dark?: boolean;
  showCorrectAction?: boolean;
}
export function ScenarioKeyTable({
  dark = false,
  showCorrectAction = false
}: Props) {
  const headRule = dark ? 'border-white/15' : 'border-rule';
  const rowRule = dark ? 'border-white/10' : 'border-rule/70';
  const headText = dark ? 'text-white/40' : 'text-muted/70';
  const bodyText = dark ? 'text-white/80' : 'text-ink';
  const accent = dark ? 'text-brand-light' : 'text-brand';
  const quiet = dark ? 'text-white/45' : 'text-muted';
  const packText = dark ? 'text-white/50' : 'text-muted';
  const packQuiet = dark ? 'text-white/35' : 'text-muted/70';
  const columns = showCorrectAction ? 5 : 4;
  return <table className="w-full border-collapse text-left" data-id="element-56" data-mp="2uostu76dqiwp">
      <thead data-id="element-57" data-mp="1ec4ajwm2vvhz">
        <tr className={`border-b ${headRule} font-mono-num text-[10px] uppercase tracking-[0.1em] ${headText}`} data-id="element-58" data-mp="1ebchotjv8bve">
          <th className="w-10 py-2 pr-3 font-medium" data-id="element-59" data-mp="1j9dw316cjn0j">SC</th>
          <th className="w-28 py-2 pr-3 font-medium" data-id="element-60" data-mp="gioc00x93a8i">Class</th>
          <th className="py-2 pr-4 font-medium" data-id="element-61" data-mp="bijvwc098hit">What was planted</th>
          {showCorrectAction && <th className="w-52 py-2 pr-4 font-medium" data-id="element-62" data-mp="bkwhcz581a0m">Full-credit action</th>}
          <th className="w-32 py-2 font-medium" data-id="element-63" data-mp="qh4529fu8tkn">Revealed by</th>
        </tr>
      </thead>
      <tbody data-id="element-64" data-mp="lf51ozk3lwnp">
        {assessmentKey.map(row => <tr key={row.sc} className={`border-b ${rowRule} align-top`} data-id="element-65" data-mp="zfz8xevetrks">
            <td className={`py-3 pr-3 font-mono-num text-[11.5px] ${quiet}`} data-id="element-66" data-mp="ze4os2ryq3hr">{row.sc}</td>
            <td className={`py-3 pr-3 font-mono-num text-[10.5px] uppercase tracking-[0.08em] ${accent}`} data-id="element-67" data-mp="ufbhwt76laqk">
              {row.klass}
            </td>
            <td className={`py-3 pr-4 text-[12.5px] leading-relaxed ${bodyText}`} data-id="element-68" data-mp="146xv2v32xjvy">{row.planted}</td>
            {showCorrectAction && <td className={`py-3 pr-4 text-[12.5px] leading-relaxed ${quiet}`} data-id="element-69" data-mp="1i78ni2k1f6j8">
                {row.correctAction}
              </td>}
            <td className={`py-3 font-mono-num text-[11px] ${accent}`} data-id="element-70" data-mp="1l93jsvrj7jo5">{row.revealedBy}</td>
          </tr>)}
      </tbody>

      <tbody data-id="element-71" data-mp="1q86gnsxcyjl1">
        <tr data-id="element-72" data-mp="1q7y27wll767q">
          <td colSpan={columns} className="pt-7" data-id="element-73" data-mp="1q5bwm2i9b0s5">
            <p className={`font-mono-num text-[10px] uppercase tracking-[0.1em] ${headText}`} data-id="element-74" data-mp="1v5q5tnvlggrr">
              Pack-level items · not scenarios
            </p>
            <p className={`mt-1.5 text-[12px] leading-relaxed ${packQuiet}`} data-id="element-75" data-mp="23z383gfjsuqi">
              Realistic loose ends. Scored only if the candidate engages with them — restraint is
              the test.
            </p>
          </td>
        </tr>
        {packLevelItems.map(row => <tr key={row.planted} className={`border-b ${rowRule} align-top`} data-id="element-76" data-mp="2dv65k8zgg574">
            <td colSpan={2} className={`py-3 pr-3 font-mono-num text-[10.5px] uppercase tracking-[0.08em] ${packQuiet}`} data-id="element-77" data-mp="2ivty4z3c0u3g">
              Pack
            </td>
            <td className={`py-3 pr-4 text-[12.5px] leading-relaxed ${packText}`} data-id="element-78" data-mp="oiulneu90g0e">{row.planted}</td>
            {showCorrectAction && <td className={`py-3 pr-4 text-[12.5px] leading-relaxed ${packQuiet}`} data-id="element-79" data-mp="2x1vxvxrrjpqy">
                {row.correctAction}
              </td>}
            <td className={`py-3 font-mono-num text-[11px] ${packQuiet}`} data-id="element-80" data-mp="2t125os7afos9">{row.revealedBy}</td>
          </tr>)}
      </tbody>
    </table>;
}